import React from "react";
import { Link } from "react-router-dom";
import { FileText, Clock, BookOpen } from "lucide-react";

const CARDS = [
  { to: "/records/documents", icon: FileText, title: "Documents", body: "Every file you've uploaded, organized by encounter." },
  { to: "/records/timeline", icon: Clock, title: "Timeline", body: "A Wikipedia-style biography of your health, year by year." },
  { to: "/records/events", icon: BookOpen, title: "All events", body: "Every lab, visit, medication and note in one place." },
];

export default function Records() {
  return (
    <div className="space-y-6" data-testid="records-page">
      <div>
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">Health records</h1>
        <p className="text-neutral-600 mt-1 text-sm">Your health, from every angle.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-3">
        {CARDS.map((c) => (
          <Link
            key={c.to}
            to={c.to}
            data-testid={`records-card-${c.title.toLowerCase()}`}
            className="bg-white rounded-2xl border border-neutral-200 p-5 hover:border-neutral-300"
          >
            <c.icon className="w-5 h-5 text-neutral-500" />
            <div className="mt-3 font-semibold">{c.title}</div>
            <div className="text-sm text-neutral-600 mt-1">{c.body}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
